// Japan
export const locale = {
  lang: 'ja',
  data: {
    TRANSLATOR: {
      SELECT: 'あなたが使う言語を選んでください',
    },
    SIDEBAR: {
      RIDES_CONFIG: 'Rides',
      RIDES_CONFIG_SETTINGS: 'Settings',
      RIDES_CONFIG_GUEST_PHONES: 'Guest phones',
      RIDES_CONFIG_PROVIDERS: 'Providers',
      FACE_VERIFICATION_CONFIG: 'Face verification',
    },
    PAGES: {
      CORPORATION_OFFICE_DETAIL: {
        TITLE: 'オフィスの詳細',
        BACK_BUTTON: '戻る',
        TAB_OVERVIEW: '一般情報',
        TAB_USERS: '割り当てられたユーザー',
        GENERAL_INFORMATION: '一般情報',
        ADDITIONAL_INFORMATION: '追加情報',
        CONTACT_PERSON: '連絡先',
        CONTACT_PHONE: '連絡先電話',
        CONTACT_EMAIL: '連絡先メール',
        STATUS: 'ステータス',
        COMMERCIAL_ADDRESS: '商用住所',
        CITY: '都市',
        POSTAL_CODE: '郵便番号',
        LOADING: 'オフィス情報を読み込み中...',
        LOADING_USERS: 'ユーザーを読み込み中...',
        ERROR: 'エラー',
        USERS: 'ユーザー',
        USER_NAME: '名前',
        USER_EMAIL: 'メール',
        USER_PHONE: '電話',
        USER_CORPORATE_EMAIL: '会社メール',
        USER_PERSONAL_EMAIL: '個人メール',
        USER_DNI: 'DNI',
        USER_DEPARTMENT: '部門',
        USER_CORPORATE_PHONE: '会社電話',
        USER_CONFIRMED: '確認済み',
        USER_ROLE: 'ロール',
        OFFICE_CODE: 'オフィスコード',
        CORPORATION: '企業',
        CREATED_AT: '作成:',
        UPDATED_AT: '更新:',
        NO_USERS: 'このオフィスにはユーザーがいません',
        WAIIS_LINK: 'WAIISで表示',
        DELETE_USER: '削除',
        DELETE_CONFIRMATION: 'このユーザーを削除してもよろしいですか?',
        DELETE_CONFIRM_BUTTON: 'はい、削除',
        DELETE_CANCEL_BUTTON: 'キャンセル',
        ACTIONS: 'アクション',
        EDIT_USER: 'ユーザーを編集',
        ADD_USER: 'ユーザーを追加',
        REQUIRED_FIELDS: '必須フィールド',
        OPTIONAL_FIELDS: 'オプションフィールド(少なくとも1つ必須)',
        NAME: '名前',
        SURNAME: '苗字',
        DEPARTMENT: '部門',
        CORPORATE_EMAIL: '会社メール',
        PERSONAL_EMAIL: '個人メール',
        DNI: 'DNI',
        CORPORATE_PHONE: '会社電話',
        PERSONAL_PHONE: '個人電話',
        CONFIRMED: '確認済み',
        STATUS_PENDING: '保留中',
        STATUS_REJECTED: '却下',
        STATUS_ACCEPTED: '承認',
        STATUS_ACTIVE: 'アクティブ',
        STATUS_INACTIVE: '非アクティブ',
        CANCEL: 'キャンセル',
        SAVE_USER: 'ユーザーを保存',
        UPDATE_USER: 'ユーザーを更新',
        WAIT: '待機',
        UPLOAD_CSV: 'CSVをアップロード',
        UPLOADING: 'アップロード中...',
        LINK_USERS: 'ユーザーをリンク',
        LINKING: 'リンク中...',
        ERROR_REQUIRED_FIELD: '必須フィールド',
        ERROR_INVALID_EMAIL: '無効なメール',
        ERROR_MIN_LENGTH: '最低2文字である必要があります',
        ERROR_INVALID_FIELD: 'フィールドが無効です',
      },
    },
    MENU: {
      NEW: '新しい',
      ACTIONS: '行動',
      CREATE_POST: '新しい投稿を作成',
      PAGES: 'Pages',
      FEATURES: '特徴',
      APPS: 'アプリ',
      DASHBOARD: 'ダッシュボード',
    },
    AUTH: {
      GENERAL: {
        OR: 'または',
        SUBMIT_BUTTON: '提出する',
        NO_ACCOUNT: 'アカウントを持っていない？',
        SIGNUP_BUTTON: 'サインアップ',
        FORGOT_BUTTON: 'パスワードをお忘れですか',
        BACK_BUTTON: 'バック',
        PRIVACY: 'プライバシー',
        LEGAL: '法的',
        CONTACT: '接触',
      },
      LOGIN: {
        TITLE: 'Create Account',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'ユーザー名',
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      },
    },
    HTTP_ERRORS: {
      FORBIDDEN: {
        TITLE: 'アクセスが拒否されました',
        MESSAGE: 'このリソースにアクセスする権限がありません。',
        CONFIRM: '了解',
      },
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted',
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created',
        },
      },
    },
    WAIIS: {
      FACE_VERIFICATION: {
        SETTINGS: {
          TITLE: 'Face verification',
          GENERAL_TITLE: 'General switch',
          KILL_SWITCH_WARNING: 'Emergency kill switch: when turned off, nobody is required to pass face verification.',
          ENABLED_LABEL: 'Face verification enabled',
          THRESHOLDS_TITLE: 'Rekognition thresholds',
          LIVENESS_THRESHOLD_LABEL: 'Liveness confidence threshold',
          LIVENESS_THRESHOLD_HINT: 'Number between 0 and 100 (decimals allowed)',
          SIMILARITY_THRESHOLD_LABEL: 'Similarity threshold',
          SIMILARITY_THRESHOLD_HINT: 'Number between 0 and 100 (decimals allowed)',
          REFERENCE_TITLE: 'Comparison reference',
          REFERENCE_TECALIS_LABEL: 'Tecalis selfie',
          REFERENCE_TECALIS_HINT: 'Always against the selfie Tecalis verified against the ID document',
          REFERENCE_ENROLLMENT_LABEL: 'Capture after near misses',
          REFERENCE_ENROLLMENT_HINT: 'First against the Tecalis selfie; after several near misses the liveness image is stored and later checks compare against it',
          ENROLLMENT_MIN_SIMILARITY_LABEL: 'Minimum similarity of a near miss',
          ENROLLMENT_MIN_SIMILARITY_HINT: 'Number between 0 and 100 (decimals allowed). A Tecalis selfie with no detectable face also counts',
          ENROLLMENT_ATTEMPTS_LABEL: 'Near misses to store the capture',
          ENROLLMENT_ATTEMPTS_HINT: 'Whole number between 1 and 10, counting all the user\'s trips',
          UPDATED_AT_LABEL: 'Last modified',
          DISABLE_CONFIRM_TITLE: 'Turn off face verification?',
          DISABLE_CONFIRM_TEXT: 'Nobody will be required to pass face verification until it is turned back on.',
          CONFIRM: 'Confirm',
          CANCEL: 'Cancel',
          SAVE: 'Save',
          SAVING: 'Saving...',
          SAVED: 'Settings saved',
          ERROR_TITLE: 'Error',
          ERROR_LOAD: 'Settings could not be loaded',
          ERROR_SAVE: 'Changes could not be saved',
          ERROR_FORBIDDEN: 'You do not have permission to perform this action',
          ACCEPT: 'Accept',
          VALIDATION: {
            REQUIRED: 'This field is required',
            INTEGER: 'The value must be an integer',
            RANGE: 'The value must be between 0 and 100',
            ATTEMPTS_RANGE: 'The value must be between 1 and 10',
          },
        },
      },
      RIDES_CONFIG: {
        SETTINGS: {
          TITLE: 'Ride settings',
          VTC_LABEL: 'VTC enabled',
          VTC_HINT: 'Controls global availability of VTC rides in the app',
          VTC_CONFIRM_TITLE: 'Are you sure?',
          VTC_DISABLE_TEXT: 'Disabling VTC will hide the request-ride button in the app for all users',
          VTC_ENABLE_TEXT: 'Enabling VTC will show the request-ride button in the app again',
          VTC_SAVED: 'VTC updated',
          CONFIRM: 'Confirm',
          CANCEL: 'Cancel',
          RIDE_PRODUCTS_ENABLED_LABEL: 'WAIIS products in estimates',
          RIDE_PRODUCTS_ENABLED_HINT: 'On: the WAIIS products are shown and, for each one, the cheapest provider. Off: the real product list of each visible provider is shown (e.g. for certifications).',
          COMMISSION_ENABLED_LABEL: 'Charge commission',
          COMMISSION_PERCENT_LABEL: 'Commission %',
          COMMISSION_PERCENT_HINT: 'Percentage between 0 and 100 (two decimals)',
          CANCELLATION_PENALTY_LABEL: 'Cancellation penalty %',
          CANCELLATION_PENALTY_HINT: 'Percentage between 0 and 100',
          REAL_FEE_ADJUSTMENT_LABEL: 'Real fee adjustment',
          REAL_FEE_ADJUSTMENT_HINT: 'Recalculate the penalty using the provider\'s real fee',
          REAL_FEE_ADJUSTMENT_ENABLED_AT_LABEL: 'Applies to rides created from',
          RECEIPT_ADJUSTMENT_LABEL: 'Receipt adjustment on completed rides',
          RECEIPT_ADJUSTMENT_HINT: 'Reconcile the difference against the amount charged when the provider receipt arrives',
          RECEIPT_ADJUSTMENT_ENABLED_AT_LABEL: 'Applies to rides created from',
          ADJUSTMENT_NEVER_ENABLED: 'Never enabled',
          SAVE: 'Save',
          SAVING: 'Saving...',
          SAVED: 'Settings saved',
          ERROR_TITLE: 'Error',
          ERROR_LOAD: 'Could not load settings',
          ERROR_SAVE: 'Could not save changes',
          ACCEPT: 'Accept',
          VALIDATION: {
            REQUIRED: 'This field is required',
            RANGE: 'Value must be between 0 and 100',
          },
        },
        GUEST_PHONES: {
          TITLE: 'Guest phones',
          EMPTY: 'No phones configured',
          TABLE: {
            PHONE_NUMBER: 'Phone number',
            ACTIVE: 'Active',
            ACTIONS: 'Actions',
          },
          ACTIONS: {
            ADD: 'Add',
            EDIT: 'Edit',
            DELETE: 'Delete',
            CANCEL: 'Cancel',
            SAVE: 'Save',
            ACCEPT: 'Accept',
          },
          MODAL: {
            CREATE_TITLE: 'New guest phone',
            EDIT_TITLE: 'Edit guest phone',
          },
          FORM: {
            PHONE_NUMBER: 'Phone number',
            PHONE_PLACEHOLDER: '+34600000000',
            PHONE_HINT: 'E.164 format: international prefix with + (e.g. +34600000000)',
          },
          VALIDATION: {
            PHONE_REQUIRED: 'Phone number is required',
            PHONE_FORMAT: 'Invalid format: use E.164 (+ and 7–15 digits)',
          },
          DELETE: {
            TITLE: 'Delete phone?',
            TEXT: '{{phone}} will be removed from the guest pool',
            CONFIRM: 'Yes, delete',
          },
          ERROR: {
            TITLE: 'Error',
          },
        },
        PROVIDERS: {
          TITLE: 'Providers and product mapping',
          RIDE_PRODUCTS: {
            TITLE: 'WAIIS products',
            HELP: 'These are the products the rider sees. Each provider maps one of its real products to every WAIIS product; the estimate shows the cheapest mapped provider.',
            ADD: 'Add WAIIS product',
            MOVE_UP: 'Move up',
            MOVE_DOWN: 'Move down',
            TABLE: {
              ORDER: 'Order',
              PRODUCT: 'Product',
              VISIBLE: 'Visible',
              ACTIONS: 'Actions',
            },
            MODAL: {
              NEW_TITLE: 'New WAIIS product',
              EDIT_TITLE: 'Edit WAIIS product',
              KEY: 'Key',
              KEY_HELP: 'Internal identifier in lowercase, digits and hyphens (e.g. go, premium-xl). It cannot be changed later.',
              DISPLAY_NAME: 'Name',
              IMAGE: 'Image',
              IMAGE_HELP: 'URL of the icon the rider sees',
              DESCRIPTION: 'Description',
              DESCRIPTION_HELP: 'Optional, per language. Only languages with text are stored.',
              VISIBLE: 'Visible',
            },
            VALIDATION: {
              KEY_REQUIRED: 'The key is required',
              KEY_FORMAT: 'Only lowercase letters, digits and hyphens (50 characters max)',
              DISPLAY_NAME_REQUIRED: 'The name is required',
            },
            CONFIRM: {
              DELETE_TITLE: 'Delete WAIIS product?',
              DELETE_TEXT: '"{{product}}" will be permanently deleted',
            },
            ERROR: {
              IN_USE: 'It cannot be deleted: there are still mappings pointing to it in {{providers}}',
            },
          },
          ROUTE: {
            TITLE: 'Sample route for product discovery',
            HELP: 'Providers only reveal their products when estimating a trip, and the catalog changes by city. Pick an origin and destination in the city you want to query: the route is saved for the whole team.',
            PICKUP: 'Origin',
            DROPOFF: 'Destination',
          },
          DISCOVER: {
            BUTTON: 'Discover provider products',
            ADD_TAG: 'Use this key: ',
            PLACEHOLDER: 'Type the key or discover the provider products',
            EMPTY: 'No products discovered yet',
            CAPACITY: '{{capacity}} seats',
            MAPPED_TO: 'Already mapped to {{product}}',
            MAPPED_HIDDEN: 'Mapped and hidden',
            REFRESH: 'Query the provider again',
            ROUTE_USED: 'Sample route: {{pickup}} → {{dropoff}}',
            NO_ROUTE: 'Set the sample route on the providers page to discover products',
            ERROR: {
              DISABLED: 'The provider is disabled on the server',
              UNAVAILABLE: 'The provider is not available right now',
              GENERIC: 'Provider products could not be discovered',
            },
          },
          ACTIONS: {
            ADD_PRODUCT: 'Add product',
            SAVE: 'Save',
            CANCEL: 'Cancel',
            ACCEPT: 'Accept',
            EDIT: 'Edit',
            DELETE: 'Delete',
          },
          FORM: {
            DISPLAY_NAME: 'Custom name',
            VISIBLE: 'Visible',
          },
          EMPTY: {
            PRODUCTS: 'This provider has no mapped products yet',
            RIDE_PRODUCTS: 'There are no WAIIS products configured',
          },
          TABLE: {
            PRODUCT_KEY: 'Provider product',
            RIDE_PRODUCT: 'WAIIS product',
            VISIBLE: 'Visible',
            ACTIONS: 'Actions',
          },
          MODAL: {
            NEW_PRODUCT: 'New product',
            EDIT_PRODUCT: 'Edit product',
            PRODUCT_KEY: 'Provider product',
            PRODUCT_KEY_HELP: 'Exact product name at the provider (e.g. UberX, Standard)',
            RIDE_PRODUCT: 'WAIIS product',
            RIDE_PRODUCT_PLACEHOLDER: 'Select a WAIIS product',
            VISIBLE: 'Visible',
          },
          VALIDATION: {
            PRODUCT_KEY_REQUIRED: 'Provider product is required',
            RIDE_PRODUCT_REQUIRED: 'WAIIS product is required',
          },
          CONFIRM: {
            DELETE_PRODUCT_TITLE: 'Delete product?',
            DELETE_PRODUCT_TEXT: '"{{product}}" will be permanently deleted',
          },
          ERROR: {
            TITLE: 'Error',
          },
          SUCCESS: {
            PROVIDER_SAVED: 'Provider saved',
          },
        },
      },
      MATCH_REVIEW: {
        DRIVER: 'ドライバー',
        PASSENGER: '乗客',
        VERIFY: '検証',
        SELECT_DRIVER: 'ドライバーを選択',
        SELECT_PASSENGER: '乗客を選択',
        DRIVER_DATA: 'ドライバーデータ',
        PASSENGER_DATA: '乗客データ',
        ROUTE_MAP: 'ルートマップ',
        NO_DATA: 'データなし',
        ENTER_ROUTINE_IDS:
          'ドライバーと乗客のルーチンIDを入力してマップでルートを表示します',
        LOADED: '読み込み済み',
        USER: 'ユーザー',
        DISTANCE: '距離',
        DURATION: '期間',
        PRICE: '価格',
        LOADING: '読み込み中',
        SHOW_HEXAGONS: 'ヘキサゴンを表示',
        SHOW_MAP_HEXAGONS: 'マップのすべてのヘキサゴンを表示',
        SHOW_POLYLINE: 'ポリラインを表示',
        ADD_DRIVER: 'ドライバーを追加',
        ADD_RIDER: '乗客を追加',
        SELECT_ROUTINE: 'ここをクリックしてルートを追加',
        NAME: '名前',
        LOCATIONS: '場所',
        ERROR_LOADING_ROUTE: 'ルートの読み込みエラー',
        SELECT_ROUTE_DETAILS: '詳細を表示するにはルートを選択してください',
        COPY_PHP_PAYLOAD: 'PHP ペイロードをコピー',
        COPIED: 'コピー済み',
        CENTER: '中央に',
        H3_RESOLUTION: 'H3解像度',
        HEXAGON_POINTS: 'ヘキサゴンポイント',
        SIGNIFICANT_POINTS: '重要なポイント',
        ALL_POINTS: 'すべてのポイント',
        ERROR: 'エラー',
        MAPS_LOAD_ERROR: 'Google Mapsの読み込みに失敗しました',
        ENTER_DRIVER_ID: 'ドライバーのルーチンIDを入力してください',
        ENTER_PASSENGER_ID: '乗客のルーチンIDを入力してください',
        ERROR_VERIFYING: '{{type}}ルーチン検証時にエラーが発生しました',
        PICKUP: 'ピックアップ {{type}}',
        ORIGIN: 'オリジン {{type}}',
        DROPOFF: 'ドロップオフ {{type}}',
        DESTINATION: '目的地 {{type}}',
        DRIVER_TEXT: 'ドライバー',
        PASSENGER_TEXT: '乗客',
        COORDINATES: '{{lat}}, {{lng}}',
        H3_INDEX: 'H3インデックス (Res {{res}})',
        LOADING_ROUTINE: 'ルーチンを読み込み中...',
        UNKNOWN_ERROR: '不明なエラー',
        SEARCH_RADIUS: '検索半径',
        RADIUS_PLACEHOLDER: '半径(メートル)',
        FOUND: '見つかった',
        INTEREST_POINTS: '関心地点',
        NO_POINTS_FOUND: '指定された半径内に関心地点が見つかりません',
        ERROR_FETCHING_POINTS: '関心地点の取得エラー',
        SEARCH_INTEREST_POINTS: '関心点を検索',
        CANCEL_SEARCH: '検索をキャンセル',
        LOAD_FROM_FILE: 'ファイルから読み込む',
        PROCESS_COMPLETE: 'プロセスが完了しました',
        CONFIRM: '確認',
      },
    },
  },
};
